const data = [
  {
    country: "Japan",
    place: "Mount Fuji",
    dates: {
      start: "12 Jan, 2021",
      end: "24 Jan, 2021",
    },
    content:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    img: "Japan.png",
  },
  {
    country: "Australia",
    place: "Sydney Opera House",
    dates: {
      start: "27 May, 2021",
      end: "8 Jun, 2021",
    },
    content:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings",
    img: "Australia.png",
  },
  {
    country: "Norway",
    place: "Geirangerfjord",
    dates: {
      start: "01 Oct, 2021",
      end: "18 Nov, 2021",
    },
    content:
      "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
    img: "Norway.png",
  },
];
export default data;
